const chats = {
  folders: {
    all: -1,
    blocked: -2,
  },
  maxGroupNameLength: 100,
  maxSearchInDialogLength: 35,
  minGroupNameLength: 3,
  minSearchInDialogLength: 3,
  minUsersCount: 2,
  searchInDialogPageSize: 10,
};

export enum ChatUserRolesEnum {
  creator = '37:201',
  admin = '37:202',
  user = '37:203',
}

export enum ChatUserPermitsEnum {
  read = '82:500',
  write = '82:501',
  manage = '82:502',
  grant_role_admin = '82:503',
  chat_delete = '82:504',
}

export default chats;
